import React, {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
interface Props {
  tabs: any[]
  className?: string
}
const CustomContentTabs: FC<Props> = ({tabs, className}) => {
  return (
    <div className={`sdx_content_tab_panel ${className}`}>
      <Tabs className='sdx_sub_react_tab_panel'>
        <TabList className='sdx_sub_tab_panel p-0'>
          {tabs.map((tab, index) => (
            <Tab key={index} className='sdx_sub_tab_panel_option'>
              {tab.label}
            </Tab>
          ))}
        </TabList>
        {tabs.map((tab, index) => (
          <TabPanel key={index}>{tab.component}</TabPanel>
        ))}
      </Tabs>
    </div>
  )
}

export default CustomContentTabs
